import React from 'react';
import '../../styles/home/member-cta.scss';

/**
 * Member call to action
 */
const MemberCTA = () => (
  <div className="home-member-cta">
    <div className="section">
      <h2>Who We Are</h2>
      <div>
        {/* eslint-disable-next-line max-len */}
        <p>The North Texas Families in Transition (NTXFIT) Professionals Workgroup is a volunteer organization of independent licensed professionals who practice around the metroplex.</p>
        {/* eslint-disable-next-line max-len */}
        <p>Our members specialize in working with families dealing with separation, divorce, co-parenting, and other situations involving raising children between multiple homes. The group includes mental health professionals, mediators, educators, and other support providers.</p>
      </div>
    </div>
  </div>
);
export default MemberCTA;
